import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/sidebar_icon.svg'

const SidebarIcon: React.FC<SvgIconProps> = props => <SvgIcon component={Icon} fill="currentColor" viewBox="0 0 30 30" {...props} />
export default SidebarIcon
